import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconEmail = ({ className, height, width, fill }: IconInterface) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 19 14'
    fill={fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.64265 0.368896H17.6389C18.1911 0.368896 18.6387 0.816507 18.6387 1.36866V12.3661C18.6387 12.9182 18.1911 13.3659 17.6389 13.3659H1.64265C1.09049 13.3659 0.642881 12.9182 0.642881 12.3661V1.36866C0.642881 0.816507 1.09049 0.368896 1.64265 0.368896ZM2.64241 2.36843V11.3663H16.6391V2.36843H2.64241Z'
      fill={fill}
    />
    <path
      d='M1.03996 2.19095L7.84019 7.27354C8.90853 8.07203 10.3758 8.06911 11.441 7.26637L18.1786 2.18856C18.6196 1.85623 18.7076 1.22937 18.3753 0.788422C18.043 0.34747 17.4161 0.259407 16.9752 0.591728L10.2375 5.66954C9.88247 5.93712 9.39337 5.93809 9.03726 5.67193L2.23703 0.589337C1.79476 0.258775 1.16825 0.349335 0.837693 0.791608C0.507131 1.23388 0.597692 1.86039 1.03996 2.19095Z'
      fill={fill}
    />
  </svg>
)

export default Icon(IconEmail)
